import { securityTypeLabels } from '~/constants'
import { SecurityType } from '~/types'

export const getSecurityType = (securityType: SecurityType): string => {
  return securityTypeLabels[securityType] ?? ''
}
